module.exports = __webpack_public_path__ + "static/media/deal-free-gift.2edf74f0.png";